module.exports = __webpack_public_path__ + "img/btn.618a6678.png";